import { ACCOUNT_TYPE } from '@/shared/constants/account-type.constant';
import { AppStorage } from '@/shared/constants/app-storage.constant';
import { AppTheme } from '@/shared/constants/app-theme.constant';
import { SCOPED_ROLE } from '@/shared/constants/scoped-role.constant';
import { createSelector } from '@/shared/lib/helpers/create-store-logic';

import { USER_REALM_ROLE } from '../constants/user-realm-role.constant';
import { userInitialState } from '../slice/user.slice';

export const [useUser] = createSelector((state) => state.user.data ?? userInitialState);

export const [useUserIsPlant] = createSelector((state) => state.user.data?.isPlant ?? userInitialState.isPlant);
export const [useUserDomains] = createSelector((state) => state.user.data?.domains ?? userInitialState.domains);

export const [useUserTheme] = createSelector((state) => state.user.data?.theme ?? AppTheme.Dark);
export const [useIsAuth] = createSelector((state) => Boolean(state.user.data));
export const [useIsInited] = createSelector((state) => state.user.inited);
export const [useIsChangeEmail] = createSelector((state) => state.user.isChangeEmail);
export const [useUserId] = createSelector((state) => state.user.data?.id || '');
export const [useEmailValidationError] = createSelector((state) => state.user.validationError?.email);

export const [useIsPlatformAdmin] = createSelector(
	(state) => state.user.data?.accountType === ACCOUNT_TYPE.PLATFORM_ADMIN,
);

export const [useCanAccessGroupManagement] = createSelector((state) => {
	const user = state.user.data;

	if (user?.accountType === ACCOUNT_TYPE.PLATFORM_ADMIN) {
		return true;
	}

	if (!user?.realmRoles?.includes(USER_REALM_ROLE.GROUP_ADMIN)) {
		return false;
	}

	return (
		(user.accountType === ACCOUNT_TYPE.B2B && user.scopedRole === SCOPED_ROLE.ADMIN) ||
		(user.accountType === ACCOUNT_TYPE.B2C && user.scopedRole === SCOPED_ROLE.OWNER)
	);
});

export const [useAutomatedPlanAccess] = createSelector((state) => state.user.data?.automatedPlanAccess ?? false);

export const [useAccessToken] = createSelector(
	(state) => localStorage.getItem(AppStorage.AccessToken) ?? state.user.accessToken,
);

export const [useTelegram] = createSelector((state) => ({
	username: state.user.data?.telegram ?? '',
}));

export const [useAllowEditDashboard] = createSelector((state) => state.user.data?.allowDashboardEdit);

export const [useIsProxyLogin] = createSelector((state) => state.user.data?.isProxyLogin);

export const [useHasMultipleDomains] = createSelector((state) => (state.user.data?.domains?.length ?? 0) > 1);
